package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "pl")
val PlStrings = Strings(
    analyzer = "Analizator",
    appreciationOverview = "Przegląd aprecjacji",
    chartLegendInterest = "Odsetki",
    chartLegendPrincipal = "Kapitał",
    chartXaxisMonths = "Miesiące",
    chartYaxisPayment = "Płatność",
    code = "pl",
    costOfCredit = "Koszt kredytu",
    creditDealAnalyzerDescription = "Wprowadź szczegóły pożyczki, aby otrzymać kompleksową analizę oferty kredytowej. Nasz analizator ocenia kluczowe wskaźniki, aby pomóc Ci zrozumieć rzeczywisty koszt pożyczki i podjąć świadomą decyzję.",
    detailsGoodRateLongTerm = "Dobra stawka, ale długi okres skutkuje wysokim całkowitym kosztem.",
    detailsHighApr = "Wysokie RRSO. ",
    detailsHighInterestCost = "Wysoki całkowity koszt odsetek.",
    detailsHighRateShortTerm = "Wysoka stawka, ale krótki okres utrzymuje całkowity koszt na niskim poziomie.",
    detailsLowApr = "Niskie RRSO. ",
    detailsLowInterestCost = "Niski całkowity koszt odsetek.",
    discountsTradeIn = "Rabaty / Wymiana",
    displayName = "Polski",
    distribution = "Dystrybucja",
    downPayment = "Wpłata własna",
    effectiveApr = "RRSO",
    headerBalance = "Saldo",
    headerDate = "Data",
    headerInterest = "Odsetki",
    headerMonth = "#",
    headerPayment = "Płatność",
    headerPrincipal = "Kapitał",
    hideDetails = "Ukryj szczegóły",
    interest = "Odsetki",
    invalidData = "Nieprawidłowe dane",
    loanAmountSupportingText = "Całkowita kwota pożyczki, w tym wszelkie dodatkowe koszty.",
    loanDetails = "Szczegóły pożyczki",
    paymentSupportingText = "Twoja szacowana miesięczna płatność.",
    paymentComposition = "Skład płatności",
    percentSymbol = "%",
    principal = "Kapitał",
    ratingBad = "Zła oferta",
    ratingExcellent = "Doskonała oferta",
    ratingFair = "Uczciwa oferta",
    ratingGood = "Dobra oferta",
    ratingPoor = "Słaba oferta",
    schedule = "Harmonogram",
    showDetails = "Pokaż szczegóły",
    summaryBad = "Bardzo niekorzystne, unikać jeśli to możliwe.",
    summaryExcellent = "Doskonałe warunki finansowe.",
    summaryFair = "Uczciwe warunki, rozważ negocjacje.",
    summaryGood = "Dobre warunki, standardowe dla rynku.",
    summaryPoor = "Słabe warunki, wysoki koszt lub stawka.",
    totalPaid = "Łącznie zapłacono",
    lockTaxRate = "Zablokuj stawkę podatku",
    unlockTaxRate = "Odblokuj stawkę podatku",
    currencySymbol = "zł",
    currency = "Waluta",
    totalCreditAmount = "Całkowita kwota kredytu",
    taxAmount = "Kwota podatku/potrącenia",
    netAmountDisbursed = "Kwota netto wypłacona",
    years = "Lata",
    loanTermTotalMonths = "Okres kredytowania (miesiące)",
    monthlyInstallment = "Miesięczna rata",
    principalInstallment = "Rata kapitałowa",
    otherFees = "Inne opłaty",
    insuranceCost = "Składka ubezpieczeniowa",
    aprc = "Rzeczywista Roczna Stopa Oprocentowania (RRSO)",
    totalAmountPayable = "Całkowita kwota do zapłaty",
    prepaidFeeFixed = "Opłata manipulacyjna (kwota stała)",
    prepaidFeePercentage = "Opłata manipulacyjna (procent)",
    months = "Miesiące",
    description = "Ten analizator pomaga ocenić, czy oferta pożyczki jest dla Ciebie korzystna. W przeciwieństwie do standardowych kalkulatorów, nie wymaga wprowadzania stopy procentowej. Zamiast tego oblicza RRSO i całkowity koszt kredytu na podstawie płatności i opłat, zapewniając ocenę oferty i szczegółowe wykresy.",
    agree = "Zgadzam się",
    information = "Informacja",
    errorCalculationOverflow = "RRSO jest za wysokie, przepełnienie obliczeń.",
    errorTotalPaymentIsLessThanLoanAmount = "Otrzymana kwota jest niższa niż kwota pożyczki.",
    errorDivisionByZero = "Dzielenie przez zero",
    errorNegativeResult = "Wynik ujemny",
    errorRateTooHigh = "Zbyt wysoka stawka",
    errorCalculation = "Wprowadź poprawne dane",
    close = "Zamknij",

    hi = "Cześć",
    guest = "Gość",
    account = "Konto",
    signInWithGoogle = "Zaloguj się przez Google",
    signOut = "Wyloguj się",
    settings = "Ustawienia",
    about = "O aplikacji",
    privacyPolicy = "Polityka prywatności",
    termsOfService = "Warunki korzystania",
    language = "Język",

    theme = "Motyw",
    light = "Jasny",
    dark = "Ciemny",
    system = "Systemowy",
    toggleExpand = "Rozwiń/Zwiń",
)
